import ThisModule from "./RescheduleMeetingWizard";

export default ThisModule;
